// extracted by mini-css-extract-plugin
module.exports = {"stepperCompleted":"#00aeef","stepperActive":"#313e49","stepperTextColor":"#fff"};